import React from "react";
import { Grid } from "@mui/material";
import EventCard from "./EventCard";
import EventDetailCard from "./EventDetailCard";

export default function EventList({ eventList, displayVer = "" }) {
  const cardList = eventList.map((event, index) => {
    return <>
      {/* (displayVer === "v2") ? ( */}
      <Grid item xs={12} sm={6} key={index}>
        <EventDetailCard event={event} />
      </Grid>
      {/* ) */}
{/* 
      (displayVer !== "v2") &&
      (
      <Grid item xs={12} sm={6} md={4} lg={3} key={index}>
        <EventCard event={event} />
      </Grid>
      ) */}
    </>

  });

  return <Grid container spacing={2} >{cardList}</Grid>;
}
